var Doosan = Doosan || {};

Doosan.Geocoder = (function () {
    function getGeocodeDataFromParams(params) {
        var deferred = $.Deferred(),
            geocoder = new google.maps.Geocoder();

        geocoder.geocode(params, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                deferred.resolve(getLocationData(results));
            }
            deferred.reject(new Error("Could not reverse geocode because of status " + status));
        });

        return deferred.promise();
    }

    function getLocationFromLatLng(lat, lng) {
        if (isNaN(lat) || isNaN(lng)) {
            return $.Deferred().resolve(null).promise();
        }
        return getGeocodeDataFromParams({ 'location': { lat: lat, lng: lng } });
    }

    function getLatLngFromZipcode(zipcode) {
        if (isNaN(zipcode)) {
            return $.Deferred().resolve(null).promise();
        }
        return getGeocodeDataFromParams({ 'componentRestrictions': { 'postalCode': zipcode } });
    }

    function getLatLngFromAddress(address) {
        if (!address) {
            return $.Deferred().resolve(null).promise();
        }
        return getGeocodeDataFromParams({ 'address': address });
    }

    function getLocationByBrowser() {
        var deferred = $.Deferred();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(deferred.resolve, deferred.reject, { timeout: 5000 });
        } else {
            //geo location isn't supported
            var e = new Error('Your browser does not support Geo Location.');
            e.NOT_SUPPORTED_ERR = true;
            deferred.reject(e);
        }
        return deferred.promise();
    }

    function getLocationComponentsFromZipcode(zipcode, country) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var params = {
             'componentRestrictions': {
                'postalCode': zipcode,
                'country': country
             }
        };

        geocoder.geocode(params, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                deferred.resolve(getLocationData(results));
            } else {
                deferred.reject(new Error('could not geocode location components from zip code ' + status));
            }
        });

        return deferred.promise();
    }

    function getAddressComponent(components, componentType) {
        for (var i = 0; i < components.length; i++) {
            var component = components[i];

            for (var j = 0; j < component.types.length; j++) {
                var type = component.types[j];

                if (type === componentType) {
                    return component;
                }
            }
        }

        return null;
    }

    function getLocationData(results) {
        var addressComponents = results[0].address_components,
            postalCode = getAddressComponent(addressComponents, 'postal_code'),
            county = getAddressComponent(addressComponents, 'administrative_area_level_2'),
            region = getAddressComponent(addressComponents, 'administrative_area_level_1'), // State/Province
            country = getAddressComponent(addressComponents, 'country');

        return {
            latitude: results[0].geometry.location.lat(),  // backward compat
            longitude: results[0].geometry.location.lng(), // backward compat
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
            viewport: results[0].geometry.viewport,
            postalCode: postalCode && postalCode.short_name ? postalCode.short_name : null,
            zip: postalCode && postalCode.short_name ? postalCode.short_name : null, // backward compat
            zipcode: postalCode && postalCode.short_name ? postalCode.short_name : null, // backward compat
            zipCode: postalCode && postalCode.short_name ? postalCode.short_name : null, // backward compat
            county: county && county.short_name ? county.short_name : null,
            region: region && region.short_name ? region.short_name : null,
            regionLong: region && region.long_name ? region.long_name : null,
            country: country && country.short_name ? country.short_name : null
        };
        
    }

    return {
        getLatLngFromZipcode: getLatLngFromZipcode,
        getLatLngFromAddress: getLatLngFromAddress,
        getLocationByBrowser: getLocationByBrowser,
        getLocationComponentsFromZipcode: getLocationComponentsFromZipcode,
        getLocationFromLatLng: getLocationFromLatLng
    };
}());